import { DropdownModule } from 'primeng/dropdown';

import { NgModule, CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA} from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';


import { MenuModule } from './_components/menu/menu.module';
import { SharedModule } from '../_theme/components/shared.module';
import { RootLayout } from '../_theme/layouts';
import { TemplateComponent } from 'src/app/_template/template.component';

import { NgIdleKeepaliveModule } from '@ng-idle/keepalive';
import { HttpClientModule } from '@angular/common/http';

import { ConfirmationService } from 'primeng/api';
import {ConfirmDialogModule} from 'primeng/confirmdialog';

import { MessageModule } from './../_theme/components/message/message.module';
import { MessageService } from './../_theme/components/message/message.service';
import { ModalModule } from 'ngx-bootstrap/modal';
import { ProfileComponent } from './_components/profile/profile.component';
import { AppSharedModule } from '../_shared/app-shared.module';
import { SearchPageComponent } from './_components/search-page/search-page.component';
import {ToastrModule} from 'ngx-toastr';
import { positionElements } from 'ngx-bootstrap/positioning/public_api';
import {TableModule} from 'primeng/table';

// COMPONENTES
import {CalendarModule} from 'primeng/calendar';

import {SidebarModule} from 'primeng/sidebar';
import {InplaceModule} from 'primeng/inplace';
import { ColorPickerModule } from "primeng/colorpicker";

import {CheckboxModule} from 'primeng/checkbox';
import {TabViewModule} from 'primeng/tabview';
import {ListboxModule} from 'primeng/listbox';
import {RadioButtonModule} from 'primeng/radiobutton';
import { from } from 'rxjs';
import { QueryModule } from './_components/query/query.module';

@NgModule({
  declarations: [
    RootLayout, 
    TemplateComponent, 
    ProfileComponent, 
    SearchPageComponent ,
  ],
  imports: [
    MenuModule,
    CommonModule,
    ReactiveFormsModule,
    RouterModule,
    SharedModule,
    PerfectScrollbarModule,
    BrowserAnimationsModule,
    HttpClientModule,
    NgIdleKeepaliveModule.forRoot(),
    ModalModule.forRoot(),
    MessageModule,
    AppSharedModule,
   // DialogModule,
   // GridModule,
   // NotificationModule,
    FormsModule,
    InplaceModule,
    DropdownModule,
    TabViewModule,
    CalendarModule,
    CheckboxModule,
    ListboxModule,
    ToastrModule.forRoot({
      timeOut: 2000,
      positionClass: 'toast-top-right',
      preventDuplicates: true
    }),
    TableModule,
    ConfirmDialogModule,
    SidebarModule,
    RadioButtonModule,
    QueryModule,
    ColorPickerModule
  ],
  exports: [
    SharedModule,
    MenuModule,
    TemplateComponent
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
  providers: [MessageService, ConfirmationService]
})
export class TemplateModule { }
